import mergeProps from "@store/utilities/mergeProps";
import { useState } from "react";

const useMergeProps = <TObject1, TObject2>(object1: TObject1, object2: TObject2): TObject1 & TObject2 => {
    const [props] = useState(() => mergeProps(object1, object2));
    return props;
};

export default useMergeProps;
